<template>
  <div class="relative" :class="containerClass">
    <div class="absolute inset-0">
      <template v-if="videoSrc">
        <video id="bg-vid" autoplay loop muted playsinline class="w-full h-full object-cover">
          <source :src="videoSrc" type="video/mp4" />
        </video>
      </template>
      <template v-else>
        <img class="w-full h-full object-cover" :src="bgSrc" alt="" />
      </template>
      <div
        class="absolute inset-0"
        aria-hidden="true"
        :style="gradientStyle"
      />
    </div>
    <div class="relative max-w-7xl mx-auto md:p-6">
      <div class="max-w-3xl mx-auto">
        <slot>
          <img v-if="imgSrc" :src="imgSrc" alt="" class="md:rounded-xl" />
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  bgSrc: { type: String, default: '' },
  videoSrc: { type: String, default: '' },
  imgSrc: { type: String, default: '' },
  gradient: { type: String, default: 'linear-gradient(to left bottom, rgba(0,0,0,0.8), rgba(0,0,0,0.8))' },
  containerClass: { type: String, default: '' }
})

const gradientStyle = computed(() => ({
  backgroundImage: props.gradient
}))
</script>
